<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin-top: 20px;">Create an organization</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!statusSucceed" class="container">
            <div class="form-group">
                <label for="Name">Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of organization">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="Description">Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of organization"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="!statusInvoking" @click="invokeCreateOrganizationUnitCommandV1" type="button" class="btn btn-primary btn-lg">Create</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h1>Congratulation!</h1>
            <h3>Organization was created. Now you can switch to this organization.</h3>
            <a class="btn btn-primary btn-lg" href="/#/admin/organizations/manage" role="button">Manage organizations</a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted } from 'vue'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCreateOrganizationUnitCommandV1 } from '@Organizations/OrganizationUnits/commands-vue-composables'

    // ---------------- local state ----------------

    const name = ref('')
    const description = ref('')

    // ---------------- command ----------------

    const {
        invokeCreateOrganizationUnitCommandV1,
        invokingCreateOrganizationUnitCommandV1,
        succeedCreateOrganizationUnitCommandV1,
        validationErrorsCreateOrganizationUnitCommandV1
    } = useCreateOrganizationUnitCommandV1(
        '0',
        name,
        description
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Create an organization'
    })

    // ---------------- derived (template compatibility) ----------------
    const statusInvoking = computed(() => invokingCreateOrganizationUnitCommandV1.value)
    const statusSucceed = computed(() => succeedCreateOrganizationUnitCommandV1.value)
    const validationErrors = computed(() => validationErrorsCreateOrganizationUnitCommandV1.value)
</script>

